import * as Sentry from '@sentry/react';

import { fetchAppNotifications } from '@/actions/appNotification';
import { fetchProjects } from '@/actions/project';
import LayoutPage from '@/components/Layout/LayoutPage';
import { fetchAwaiting, fetchConfirmed } from '@/consultation/store';

import { LegacyRoute } from '../routesMiddleware';
import Dashboard from './DashboardPage';

const route: LegacyRoute = {
  path: '/dashboard',
  title: 'Dashboard',

  async action({ store }) {
    const cursor = '';

    // ENG-5506: notifications are banners, not the dashboard, so it renders without waiting
    // for them and AppNotifications shows them when they land. A failed query is reported
    // and leaves the collection unloaded, so the next visit tries again.
    store.dispatch(fetchAppNotifications()).catch((err: unknown) => Sentry.captureException(err));

    store.dispatch(fetchAwaiting(cursor, 1000, false, 'dashboardAwaiting'));
    store.dispatch(fetchConfirmed(cursor, 1000, false, 'dashboardConfirmed'));
    store.dispatch(
      fetchProjects({
        collection: 'dashboard',
        pageSize: 1000,
        openOnly: true,
        memberOnly: true,
      })
    );

    document.title = 'Dashboard';
    return (
      <LayoutPage showNav selected="dashboard" wide>
        <Dashboard />
      </LayoutPage>
    );
  },
};

export default route;
